/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_AnnualConfirmationMonthDTO } from './billing_AnnualConfirmationMonthDTO';
import type { billing_AnnualConfirmationPayerDTO } from './billing_AnnualConfirmationPayerDTO';
export type billing_AnnualConfirmationChildDTO = {
    address_missing?: boolean;
    birthdate?: string;
    child_id: string;
    /**
     * FiguresChanged: FINAL, and the live figures differ from the snapshot.
     */
    figures_changed?: boolean;
    /**
     * FinalizedAt (RFC 3339) and FinalizedByName are set for FINAL only; the
     * name is empty when the user is not on the staff roster.
     */
    finalized_at?: string;
    finalized_by_name?: string;
    /**
     * IncludeExtras: the additional services are part of the figures (#1976).
     */
    include_extras?: boolean;
    months: Array<billing_AnnualConfirmationMonthDTO>;
    name: string;
    payer?: billing_AnnualConfirmationPayerDTO;
    /**
     * Status is DRAFT or FINAL (#1975).
     */
    status: billing_AnnualConfirmationChildDTO.status;
    total_cents?: number;
};
export namespace billing_AnnualConfirmationChildDTO {
    /**
     * Status is DRAFT or FINAL (#1975).
     */
    export enum status {
        DRAFT = 'DRAFT',
        FINAL = 'FINAL',
    }
}

